import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

const PROVINCIAS_EC = [
  'Azuay', 'Bolívar', 'Cañar', 'Carchi', 'Chimborazo', 'Cotopaxi', 'El Oro',
  'Esmeraldas', 'Galápagos', 'Guayas', 'Imbabura', 'Loja', 'Los Ríos',
  'Manabí', 'Morona Santiago', 'Napo', 'Orellana', 'Pastaza', 'Pichincha',
  'Santa Elena', 'Santo Domingo de los Tsáchilas', 'Sucumbíos', 'Tungurahua', 'Zamora Chinchipe',
];

function vacio() {
  return {
    nombre_completo: '', email: '', whatsapp: '',
    ciudad_origen: '', estado_usa: '', zip_code: '',
    peso_lb: '', largo: '', ancho: '', alto: '', num_paquetes: 1,
    contenido_descripcion: '', valor_declarado: '', condicion: '',
    ciudad_destino_ec: '', provincia_ec: '',
  };
}

/**
 * Para solicitudes que llegan por fuera del formulario (WhatsApp, correo,
 * una llamada) — típicamente de alguien que todavía no es cliente
 * registrado. Crea la solicitud con `cliente=None` (igual que el
 * formulario público) para que el admin pueda cotizarla de una vez; si la
 * persona después crea una cuenta con este mismo correo, se vincula sola
 * (ver activar_cuenta_view). No obliga a nada — si decide no enviar el
 * paquete, la solicitud simplemente queda sin vincular, sin romper nada.
 */
export default function NuevaSolicitudPuertaPuertaAdminModal({ onClose, onCreada }) {
  const [datos, setDatos] = useState(vacio());
  const [enviando, setEnviando] = useState(false);

  const set = (campo, valor) => setDatos((d) => ({ ...d, [campo]: valor }));

  const enviar = async (e) => {
    e.preventDefault();
    if (!datos.nombre_completo.trim() || !datos.email.trim() || !datos.whatsapp.trim() || !datos.ciudad_origen.trim()) {
      toast.error('Completa al menos nombre, correo, WhatsApp y ciudad de origen.');
      return;
    }
    setEnviando(true);
    try {
      const form = new FormData();
      Object.entries(datos).forEach(([k, v]) => {
        if (v !== '' && v !== null) form.append(k, v);
      });
      form.append('terminos_aceptados', true);

      const res = await api.post('/puerta-a-puerta/', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Solicitud creada — ya puedes cotizarla.');
      onCreada(res.data);
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo crear la solicitud.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Nueva solicitud (manual)</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>
        <p className="text-sm text-secondary" style={{ marginTop: '2px' }}>
          Para solicitudes que te llegan por WhatsApp, correo o llamada — normalmente de alguien que todavía no tiene cuenta en el panel.
        </p>

        <form onSubmit={enviar} className="form-stack">
          <div className="form-row">
            <div>
              <label>Nombre completo *</label>
              <input value={datos.nombre_completo} onChange={(e) => set('nombre_completo', e.target.value)} />
            </div>
          </div>
          <div className="form-row">
            <div>
              <label>Email *</label>
              <input type="email" value={datos.email} onChange={(e) => set('email', e.target.value)} />
            </div>
            <div>
              <label>WhatsApp *</label>
              <input value={datos.whatsapp} onChange={(e) => set('whatsapp', e.target.value)} placeholder="+1 786 000 0000" />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Ciudad de origen (USA) *</label>
              <input value={datos.ciudad_origen} onChange={(e) => set('ciudad_origen', e.target.value)} />
            </div>
            <div>
              <label>Estado</label>
              <input value={datos.estado_usa} onChange={(e) => set('estado_usa', e.target.value)} placeholder="FL, TX, NY..." />
            </div>
            <div>
              <label>ZIP Code</label>
              <input value={datos.zip_code} onChange={(e) => set('zip_code', e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Peso aprox. (lb)</label>
              <input type="number" step="0.01" min="0" value={datos.peso_lb} onChange={(e) => set('peso_lb', e.target.value)} />
            </div>
            <div>
              <label>Largo (in)</label>
              <input type="number" step="0.01" min="0" value={datos.largo} onChange={(e) => set('largo', e.target.value)} />
            </div>
            <div>
              <label>Ancho (in)</label>
              <input type="number" step="0.01" min="0" value={datos.ancho} onChange={(e) => set('ancho', e.target.value)} />
            </div>
            <div>
              <label>Alto (in)</label>
              <input type="number" step="0.01" min="0" value={datos.alto} onChange={(e) => set('alto', e.target.value)} />
            </div>
            <div>
              <label>Nº de paquetes</label>
              <input type="number" min="1" value={datos.num_paquetes} onChange={(e) => set('num_paquetes', e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Contenido</label>
              <input value={datos.contenido_descripcion} onChange={(e) => set('contenido_descripcion', e.target.value)} placeholder="Ropa, zapatos, electrónicos..." />
            </div>
            <div>
              <label>Valor declarado (USD)</label>
              <input type="number" step="0.01" min="0" value={datos.valor_declarado} onChange={(e) => set('valor_declarado', e.target.value)} />
            </div>
            <div>
              <label>Condición</label>
              <select value={datos.condicion} onChange={(e) => set('condicion', e.target.value)}>
                <option value="">—</option>
                <option value="nuevo">Nuevo</option>
                <option value="usado">Usado</option>
                <option value="mixto">Mixto</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Ciudad de destino (Ecuador)</label>
              <input value={datos.ciudad_destino_ec} onChange={(e) => set('ciudad_destino_ec', e.target.value)} />
            </div>
            <div>
              <label>Provincia</label>
              <select value={datos.provincia_ec} onChange={(e) => set('provincia_ec', e.target.value)}>
                <option value="">—</option>
                {PROVINCIAS_EC.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={enviando}>
              <Send size={16} /> {enviando ? 'Creando...' : 'Crear solicitud'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
